import { DISABLED_OPACITY as r } from "../../styles/colors/consts.js";
function t(e = "", o) {
  return `rgba(${e.replace("#", "").split(/(.{2})/g).filter(Boolean).map(a).join(",")}, ${o})`;
}
function s(e) {
  return t(e, parseFloat(r));
}
function a(e) {
  return parseInt(e, 16);
}
export {
  s as colorWithDisabledOpacity,
  t as default,
  a as hexToDecimal
};
